import { LazyLoadUtils } from "../../utils/index.js";
import { ClientProviderEnum } from "../../constants/index.js";

export const OddsMobile = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "odds/mobile/odds" */
      "./Odds.mobile.js"
    ),
  { componentName: "OddsMobile" }
);

export const OddsPC = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "odds/pc/odds" */
      "./Odds.pc.js"
    ),
  { componentName: "OddsPC" }
);

/**
 * Preload odds components for performance optimization
 * Triggers the dynamic import without rendering the component
 */
export const preload = ({ isPC, clientProvider }) => {
  if (clientProvider === ClientProviderEnum.Spectate) {
    if (isPC) {
      OddsPC.preload();
    } else {
      OddsMobile.preload();
    }
  }
};
